'use client';

import {useMediaQuery} from '@mui/material';

const desktopMedia = '(min-width: 1024px)';

export function useIsDesktop() {
  const matches = useMediaQuery(desktopMedia);
  return matches;
}
